<template>
  <div class="container">
    <el-form ref="form" :model="queryForm" label-width="80px">
      <el-row :gutter="20">
        <el-col :span="6">
          <el-form-item label="选择日期">
            <el-date-picker
              style="width: 100%"
              v-model="queryForm.daterange"
              type="daterange"
              value-format="timestamp"
              :default-time="['00:00:00', '23:59:59']"
              range-separator="-"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="运营助理">
            <el-select v-model="queryForm.operationsAssistantId" filterable clearable placeholder="请选择运营助理">
              <el-option v-for="item in boutiqueBdList" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="状态">
            <el-select v-model="queryForm.status" clearable placeholder="请选择状态">
              <el-option label="审批完成" :value="2"></el-option>
              <el-option label="待审批" :value="1"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-button type="primary" @click="search">搜索</el-button>
        </el-col>
      </el-row>
    </el-form>
    <el-button type="primary" @click="batchRejectOrPassAll(2)">豁免</el-button>
    <el-button type="info" @click="batchRejectOrPassAll(3)">驳回</el-button>
    <el-table v-loading="loading" ref="table" :data="tableData" @expand-change="expandChange" row-key="exemptionId" style="width: 100%">
      <el-table-column label="" width="35">
        <template slot="header" slot-scope="scope">
          <el-checkbox v-model="checkedAll" @change="clickCheckedAll"></el-checkbox>
        </template>
        <template slot-scope="scope">
          <el-checkbox v-model="scope.row.checked" v-if="scope.row.status === 1" @change="(value) => clickItemChecked(value, scope)"></el-checkbox>
        </template>
      </el-table-column>
      <el-table-column type="expand">
        <template slot-scope="props">
          <el-table :data="props.row.subList" style="width: 100%">
            <el-table-column label="" width="35">
              <template slot="header" slot-scope="scope">
                <!-- 更新不及时 -->
                <!-- <el-checkbox v-model="props.row.checked" v-if="props.row.status === 1" @change="(value) => clickSubCheckedAll(value, props)"></el-checkbox> -->
              </template>
              <template slot-scope="scope">
                <el-checkbox v-model="scope.row.checked" v-if="scope.row.status === 1" @change="(value) => clickSubItemChecked(value, props)"></el-checkbox>
              </template>
            </el-table-column>
            <el-table-column prop="vendorName" label="买手店"></el-table-column>
            <el-table-column prop="orderLineNum" label="order_line_num"></el-table-column>
            <el-table-column>
              <template slot="header" slot-scope="scope">
                创建时间<br />(UTC +8)
              </template>
              <template slot-scope="scope">
                {{ scope.row.createTime && scope.row.createTime.split(' ')[0] }}<br>
                {{ scope.row.createTime && scope.row.createTime.split(' ')[1] }}
              </template>
            </el-table-column>
            <el-table-column v-if="props.row.orderBreakType === '取消订单' || props.row.orderBreakType === '确认取消'">
              <template slot="header" slot-scope="scope">
                取消时间<br />(UTC +8)
              </template>
              <template slot-scope="scope">
                {{ scope.row.cancelTime && scope.row.cancelTime.split(' ')[0] }}<br>
                {{ scope.row.cancelTime && scope.row.cancelTime.split(' ')[1] }}
              </template>
            </el-table-column>
            <el-table-column v-if="props.row.orderBreakType === '延迟发货'">
              <template slot="header" slot-scope="scope">
                发货时间<br />(UTC +8)
              </template>
              <template slot-scope="scope">
                {{ scope.row.orderShippedAt && scope.row.orderShippedAt.split(' ')[0] }}<br>
                {{ scope.row.orderShippedAt && scope.row.orderShippedAt.split(' ')[1] }}
              </template>
            </el-table-column>
            <el-table-column v-if="props.row.orderBreakType === '错发货' || props.row.orderBreakType === '漏发货'">
              <template slot="header" slot-scope="scope">
                错漏判责时间<br />(UTC +8)
              </template>
              <template slot-scope="scope">
                {{ scope.row.errorResponsibleConfirmedAt && scope.row.errorResponsibleConfirmedAt.split(' ')[0] }}<br>
                {{ scope.row.errorResponsibleConfirmedAt && scope.row.errorResponsibleConfirmedAt.split(' ')[1] }}
              </template>
            </el-table-column>
            <el-table-column v-if="props.row.orderBreakType === '瑕疵'">
              <template slot="header" slot-scope="scope">
                瑕疵判责时间<br />(UTC +8)
              </template>
              <template slot-scope="scope">
                {{ scope.row.flawResponsibleConfirmedAt && scope.row.flawResponsibleConfirmedAt.split(' ')[0] }}<br>
                {{ scope.row.flawResponsibleConfirmedAt && scope.row.flawResponsibleConfirmedAt.split(' ')[1] }}
              </template>
            </el-table-column>
            <el-table-column prop="orderBreakTypeName" label="违规类型"></el-table-column>
            <el-table-column prop="orderBreakLenWorkDay" label="时长/级别">
              <template slot-scope="scope">
                {{ scope.row.breakDay }}
              </template>
            </el-table-column>
            <el-table-column label="审批结果">
              <template slot-scope="scope">
                <div class="tag success" v-if="scope.row.status == 2">豁免通过</div>
                <div class="tag" v-if="scope.row.status == 3">已驳回</div>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="180px">
              <template slot-scope="scope">
                <el-button size="mini" v-if="scope.row.status == 1" type="primary" @click="batchRejectOrPassItem(scope.row, 2)">豁免</el-button>
                <el-button size="mini" v-if="scope.row.status == 1" type="info" @click="batchRejectOrPassItem(scope.row, 3)">驳回</el-button>
                <el-button size="mini" v-if="scope.row.status != 1" type="warning" @click="showModifyStatus(scope.row)">修改审批结果</el-button>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </el-table-column>
      <el-table-column prop="operationsAssistantName" label="运营助理"></el-table-column>
      <el-table-column label="违约原因">
        <template slot-scope="scope">
          {{ scope.row.defaultReasonName }}
          <el-popover
            v-if="scope.row.defaultReasonRemark"
            placement="top-start"
            width="200"
            trigger="hover"
            :content="scope.row.defaultReasonRemark"
          >
            <el-button slot="reference" type="text">备注</el-button>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column label="豁免原因">
        <template slot-scope="scope">
          {{ scope.row.exemptionReasonName }}
          <el-popover
            v-if="scope.row.exemptionRemark" 
            placement="top-start"
            width="200"
            trigger="hover"
            :content="scope.row.exemptionRemark"
          >
            <el-button slot="reference" type="text">备注</el-button>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column prop="creatorName" label="申请人"></el-table-column>
      <el-table-column prop="createdAt" label="申请时间">
        <template slot-scope="scope">
          {{ scope.row.createdAt && scope.row.createdAt.split(' ')[0] }}<br>
          {{ scope.row.createdAt && scope.row.createdAt.split(' ')[1] }}
        </template>
      </el-table-column>
      <el-table-column label="状态">
        <template slot-scope="scope">
          <div class="tag primary" v-if="scope.row.status === 1">
            待审批
          </div>
          <div
            class="tag success"
            v-if="scope.row.status === 2 || scope.row.status === 3"
          >
            审批完成
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="pagination"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="queryForm.pageNo"
      :page-sizes="[10, 20, 30, 50]"
      :page-size="queryForm.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>

    <el-dialog title="修改审批结果" :visible.sync="dialogVisible" width="500px">
      审批结果：
      <el-radio-group v-model="status">
        <el-radio :label="2">豁免</el-radio>
        <el-radio :label="3">驳回</el-radio>
      </el-radio-group>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitStatus">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getUserList } from '../../buyershop/api';
import { formatDateTime, changeParams } from "@/utils/functions";
import { getExemptionAuditList, getExemptionDetailAuditList, batchRejectOrPass } from "./api";
export default {
  props: {
    type: Number, // 0
    query: Boolean,
  },
  data() {
    const startTime = new Date().getTime() - 1000 * 60 * 60 * 24 * 6;
    const startDate = new Date(startTime);
    startDate.setHours(0);
    startDate.setMinutes(0);
    startDate.setSeconds(0);
    const endDate = new Date();
    endDate.setHours(23);
    endDate.setMinutes(59);
    endDate.setSeconds(59);
    return {
      loading: false,
      queryForm: {
        pageNo: 1,
        pageSize: 10,
        status: null,
        operationsAssistantId: null,
        daterange: [startDate.getTime(), endDate.getTime()],
      },
      total: 0,
      tableData: [],
      boutiqueBdList: [],
      checkedAll: false,
      dialogVisible: false,
      status: null,
    };
  },
  mounted() {
    getUserList().then(res => {
      this.boutiqueBdList = res && res.data.map(item => {
        return {
          value: item.deptUserId,
          label: item.deptUserName
        }
      })
    })
    this.getTableData();
  },
  methods: {
    search() {
      this.queryForm.pageNo = 1;
      this.getTableData();
    },
    getTableData() {
      this.loading = true;
      getExemptionAuditList({
        currentPage: this.queryForm.pageNo,
        pageSize: this.queryForm.pageSize,
        operationsAssistantId: this.queryForm.operationsAssistantId,
        status: this.queryForm.status,
        startTime: this.queryForm.daterange[0] || null,
        endTime: this.queryForm.daterange[1] || null,
      }).then(res => {
        this.total = res.data.data.total;
        if (res.data.data.list.length > 0) {
          res.data.data.list = res.data.data.list.map((item) => {
            item.subList = [];
            item.checked = false;
            return item;
          });
        }
        this.foldRows();
        this.tableData = res.data.data.list;
        this.loading = false;
      })
    },
    foldRows() {
      this.tableData.forEach((row) => {
        this.$refs.table.toggleRowExpansion(row, false)
      })
    },
    expandChange(row) {
      if (!row.subList || row.subList.length === 0) {
        getExemptionDetailAuditList({
          exemptionId: row.exemptionId
        }).then(res => {
          let index = 0;
          const data = res.data.data.map(item => {
            if (item.status == 1) {
              item.checked = row.checked;
            }
            return item;
          })
          const flag = this.tableData.some((item, i) => {
            index = i;
            return item.exemptionId === row.exemptionId;
          })
          if (flag) {
            this.tableData[index].subList = res.data.data
            this.tableData = JSON.parse(JSON.stringify(this.tableData))
          }
        })
      }
    },
    handleSizeChange(pageSize) {
      this.queryForm.pageSize = pageSize;
      this.getTableData();
    },
    handleCurrentChange(pageNo) {
      this.queryForm.pageNo = pageNo;
      this.getTableData();
    },
    batchRejectOrPassItem(row, status) {
      this.$confirm(`确认${status == 2 ? '豁免' : '驳回'} ${row.orderLineNum} 吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.batchRejectOrPass([],[row.exemptionDetailId], status);
      }).catch(() => {         
      });
    },
    batchRejectOrPassAll(status) {
      this.$confirm(`确认${status == 2 ? '豁免' : '驳回'}选中的条目吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const exemptionIdList = [];
        const exemptionDetailIdList = [];
        this.tableData.forEach(item => {
          if (item.checked) {
            if (item.status == 1) {
              exemptionIdList.push(item.exemptionId);
            }
          } else {
            item.subList.forEach(item2 => {
              if (item2.status == 1 && item2.checked) {
                exemptionDetailIdList.push(item2.exemptionDetailId);
              }
            })
          }
        })
        this.batchRejectOrPass(exemptionIdList,exemptionDetailIdList, status);
      }).catch(() => {         
      });
    },
    batchRejectOrPass(exemptionIdList, exemptionDetailIdList, status) {
      if (this.submitRepeat) {
        return;
      }
      this.submitRepeat = true;
      batchRejectOrPass({
        exemptionIdList,
        exemptionDetailIdList,
        status,
      }).then(res => {
        this.$message.success('操作成功');
        this.getTableData();
        this.dialogVisible = false;
        this.submitRepeat = false;
      }).catch(() => {
        this.submitRepeat = false;
      })
    },
    clickCheckedAll(value) {
      this.tableData = this.tableData.map(item => {
        item.checked = value;
        return item;
      });
    },
    // clickSubCheckedAll(value, props) {
    //   this.tableData[props.$index].subList = this.tableData[props.$index].subList.map(item => {
    //     if (item.status == 1) {
    //       item.checked = value;
    //     }
    //     return item;
    //   })
    //   this.tableData[props.$index].checked = value;
    // },
    clickItemChecked(value, scope) {
      this.tableData[scope.$index].subList = scope.row.subList.map(item => {
        if (item.status == 1) {
          item.checked = value;
        }
        return item;
      })
      this.tableData[scope.$index].checked = value;
      this.clickCheckedAll = this.tableData.every(item => item.checked);
    },
    clickSubItemChecked(value, props) {
      this.tableData[props.$index].checked = this.tableData[props.$index].subList.every(item => {
        if (item.status !== 1) {
          return true;
        }
        return item.checked;
      })
    },
    showModifyStatus(row) {
      this.status = row.status;
      this.modifyExemptionDetailId = row.exemptionDetailId;
      this.dialogVisible = true;
    },
    submitStatus() {
      this.batchRejectOrPass([],[this.modifyExemptionDetailId], this.status);
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  padding: 10px;
}
.ml10 {
  margin-left: 10px;
}
.pagination {
  margin-top: 10px;
  text-align: right;
}
.tag {
  display: inline-block;
  padding: 0 5px;
  font-size: 12px;
  line-height: 20px;
  white-space: nowrap;
  border: 1px solid #dcdfe6;
  border-radius: 5px;

  &.success {
    color: #fff;
    background-color: #67c23a;
    border-color: #67c23a;
  }
  &.primary {
    color: #fff;
    background-color: #409eff;
    border-color: #409eff;
  }
}
</style>
